import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ height: `${$data.vh - 170}px` }),
    class: "flex align-items-center justify-content-center pt-3 pb-3"
  }, null, 4))
}